import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { collection, getDocs, query, orderBy, addDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { sendBroadcastEmail } from '../utils/emailService';
import './EmailBroadcastPage.css';
import Swal from 'sweetalert2';

// Icon Components (reuse style of other admin pages)
const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DashboardIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M0 1C0 0.45 0.45 0 1 0H6C6.55 0 7 0.45 7 1V6C7 6.55 6.55 7 6 7H1C0.45 7 0 6.55 0 6V1ZM9 1C9 0.45 9.45 0 10 0H15C15.55 0 16 0.45 16 1V6C16 6.55 15.55 7 15 7H10C9.45 7 9 6.55 9 6V1ZM0 10C0 9.45 0.45 9 1 9H6C6.55 9 7 9.45 7 10V15C7 15.55 6.55 16 6 16H1C0.45 16 0 15.55 0 15V10ZM9 10C9 9.45 9.45 9 10 9H15C15.55 9 16 9.45 16 10V15C16 15.55 15.55 16 15 16H10C9.45 16 9 15.55 9 15V10Z" fill="currentColor" />
  </svg>
);

const RegistrationsIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
    <path d="M0 0V16H20V0H0ZM2 2H18V14H2V2ZM4 4H16V6H4V4ZM4 8H16V10H4V8ZM4 12H12V14H4V12Z" fill="currentColor" />
  </svg>
);

const TicketIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
    <path d="M0 2C0 1.45 0.45 1 1 1H17C17.55 1 18 1.45 18 2V4C17.45 4 17 4.45 17 5C17 5.55 17.45 6 18 6V8C18 8.55 17.55 9 17 9H1C0.45 9 0 8.55 0 8V6C0.55 6 1 5.55 1 5C1 4.45 0.55 4 0 4V2Z" fill="currentColor" />
  </svg>
);

const CheckInIcon = () => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path d="M0 1V15H14V1H0ZM2 3H12V13H2V3ZM6 5H8V7H6V5ZM6 9H8V11H6V9Z" fill="currentColor" />
  </svg>
);

const ExportIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M0 0V16H16V0H0ZM2 2H14V14H2V2ZM4 4H12V6H4V4ZM4 8H12V10H4V8ZM4 12H8V14H4V12Z" fill="currentColor" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 12.5C11.38 12.5 12.5 11.38 12.5 10C12.5 8.62 11.38 7.5 10 7.5C8.62 7.5 7.5 8.62 7.5 10C7.5 11.38 8.62 12.5 10 12.5ZM15.92 6.42L14.5 5C14.5 3.62 13.38 2.5 12 2.5L10.58 1.08C9.2 1.08 8.08 2.2 8.08 3.58L6.66 5C5.28 5 4.16 6.12 4.16 7.5L2.74 8.92C2.74 10.3 3.86 11.42 5.24 11.42L6.66 12.84C6.66 14.22 7.78 15.34 9.16 15.34L10.58 16.76C11.96 16.76 13.08 15.64 13.08 14.26L14.5 12.84C15.88 12.84 17 11.72 17 10.34L18.42 8.92C18.42 7.54 17.3 6.42 15.92 6.42Z" fill="currentColor" />
  </svg>
);

const BroadcastIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2H18C19.1 2 20 2.9 20 4V12C20 13.1 19.1 14 18 14H2C0.9 14 0 13.1 0 12V4C0 2.9 0.9 2 2 2ZM18 4L10 8.5L2 4V4L10 0.5L18 4ZM2 6V12H18V6L10 10.5L2 6Z" fill="currentColor" />
  </svg>
);

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 14H2C1.45 14 1 13.55 1 13V3C1 2.45 1.45 2 2 2H6V0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H6V14ZM11.59 10.59L9.59 12.59L11.18 14.18L15.36 10L11.18 5.82L9.59 7.41L11.59 9.41H5V11.41H11.59Z" fill="currentColor" />
  </svg>
);

function EmailBroadcastPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [paidRecipients, setPaidRecipients] = useState([]);
  const [recentBroadcasts, setRecentBroadcasts] = useState([]);
  const [loadingBroadcasts, setLoadingBroadcasts] = useState(true);

  const paidStatuses = ['paid'];

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          emailVerified: firebaseUser.emailVerified
        });
        await Promise.all([fetchPaidRecipients(), fetchRecentBroadcasts()]);
      } else {
        navigate('/admin');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const fetchPaidRecipients = async () => {
    try {
      setLoading(true);
      const registrationsRef = collection(db, 'registrations');
      const q = query(registrationsRef, orderBy('registeredAt', 'desc'));
      const snapshot = await getDocs(q);

      const allRegistrations = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const recipients = allRegistrations.filter(
        reg => paidStatuses.includes(reg.status) && reg.email
      );

      setPaidRecipients(recipients);
    } catch (error) {
      console.error('Error fetching paid recipients:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load paid attendees. Please try again.',
        confirmButtonColor: '#b91c1c'
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchRecentBroadcasts = async () => {
    try {
      setLoadingBroadcasts(true);
      const broadcastsRef = collection(db, 'emailBroadcasts');
      const q = query(broadcastsRef, orderBy('sentAt', 'desc'));
      const snapshot = await getDocs(q);

      const broadcasts = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setRecentBroadcasts(broadcasts);
    } catch (error) {
      console.error('Error fetching recent broadcasts:', error);
    } finally {
      setLoadingBroadcasts(false);
    }
  };

  const findPreviousBroadcast = async (subjectText, messageBody) => {
    try {
      const broadcastsRef = collection(db, 'emailBroadcasts');
      const snapshot = await getDocs(broadcastsRef);

      // Normalize inputs for comparison
      const normalizedSubject = subjectText.trim();
      const normalizedMessage = messageBody.trim();

      // Find all broadcasts with matching subject AND messageBody
      const matchingBroadcasts = snapshot.docs.filter(doc => {
        const data = doc.data();
        const dataSubject = (data.subject || '').trim();
        const dataMessage = (data.messageBody || '').trim();
        return dataSubject === normalizedSubject && dataMessage === normalizedMessage;
      });

      if (matchingBroadcasts.length === 0) {
        return null;
      }

      // Aggregate all recipientIds from all matching broadcasts
      const allRecipientIds = new Set();
      matchingBroadcasts.forEach(doc => {
        const data = doc.data();
        if (data.recipientIds && Array.isArray(data.recipientIds)) {
          data.recipientIds.forEach(id => allRecipientIds.add(id));
        }
      });

      return {
        recipientIds: Array.from(allRecipientIds),
        count: matchingBroadcasts.length
      };
    } catch (error) {
      console.error('Error finding previous broadcast:', error);
      return null;
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Unknown';

    // Handle Firestore Timestamp
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

    // Format as date
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('adminUser');
      sessionStorage.removeItem('adminUser');
      navigate('/admin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleNavClick = (path) => {
    closeSidebar();
    navigate(path);
  };

  const getUserInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const handleSendBroadcast = async () => {
    if (!subject.trim() || !message.trim()) {
      await Swal.fire({
        icon: 'warning',
        title: 'Missing fields',
        text: 'Please enter both a subject and message body.',
        confirmButtonColor: '#f59e0b'
      });
      return;
    }

    if (!paidRecipients.length) {
      await Swal.fire({
        icon: 'info',
        title: 'No paid attendees',
        text: 'There are currently no paid attendees to send this email to.',
        confirmButtonColor: '#003399'
      });
      return;
    }

    // Check if this email was sent before
    const previousBroadcast = await findPreviousBroadcast(subject.trim(), message.trim());
    let recipientsToSend = [];
    let isNewEmail = true;

    if (previousBroadcast && previousBroadcast.recipientIds) {
      // Same email - only send to new users who haven't received it
      const previousRecipientIds = previousBroadcast.recipientIds || [];
      recipientsToSend = paidRecipients.filter(reg => !previousRecipientIds.includes(reg.id));
      isNewEmail = false;
    } else {
      // Different email - send to all paid users
      recipientsToSend = paidRecipients;
    }

    if (recipientsToSend.length === 0) {
      await Swal.fire({
        icon: 'info',
        title: 'No new recipients',
        text: isNewEmail
          ? 'All paid attendees have already received this email.'
          : 'There are no new paid attendees to send this email to.',
        confirmButtonColor: '#003399'
      });
      return;
    }

    const confirmResult = await Swal.fire({
      icon: 'question',
      title: 'Send email broadcast?',
      html: isNewEmail
        ? `<p>This will send a <strong>new email</strong> to ${recipientsToSend.length} paid attendee(s).</p>`
        : `<p>This email was sent before. It will be sent to <strong>${recipientsToSend.length} new</strong> paid attendee(s) who haven't received it yet.</p>`,
      showCancelButton: true,
      confirmButtonText: 'Yes, send',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#6b7280'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    setSending(true);
    let successCount = 0;
    let errorCount = 0;
    const successfulRecipientIds = [];

    try {
      for (const reg of recipientsToSend) {
        const ok = await sendBroadcastEmail({
          toEmail: reg.email,
          toName: reg.fullName || reg.email,
          subject: subject.trim(),
          messageBody: message.trim()
        });
        if (ok) {
          successCount += 1;
          successfulRecipientIds.push(reg.id);
        } else {
          errorCount += 1;
        }
      }

      // Save broadcast record to Firestore
      if (successCount > 0) {
        const broadcastData = {
          subject: subject.trim(),
          messageBody: message.trim(),
          sentAt: serverTimestamp(),
          sentBy: user?.email || 'admin',
          recipientIds: successfulRecipientIds,
          totalSent: successCount,
          totalFailed: errorCount,
          isNewEmail: isNewEmail
        };

        // Always create a new broadcast record (for history tracking)
        await addDoc(collection(db, 'emailBroadcasts'), broadcastData);

        // Refresh recent broadcasts
        await fetchRecentBroadcasts();
      }

      await Swal.fire({
        icon: errorCount === 0 ? 'success' : 'warning',
        title: 'Broadcast completed',
        html: `<p><strong>Sent successfully:</strong> ${successCount}</p><p><strong>Failed:</strong> ${errorCount}</p>${isNewEmail ? '' : '<p><em>Only new recipients received this email.</em></p>'}`,
        confirmButtonColor: '#10b981'
      });

      // Clear form if all successful
      if (errorCount === 0) {
        setSubject('');
        setMessage('');
      }
    } catch (error) {
      console.error('Error sending broadcast:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while sending the broadcast. Please try again.',
        confirmButtonColor: '#b91c1c'
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="broadcast-page-container">
      {/* Mobile Overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* Sidebar */}
      <aside className={`dashboard-sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Close Button for Mobile */}
        <button className="sidebar-close-button" onClick={closeSidebar} aria-label="Close menu">
          <CloseIcon />
        </button>

        {/* Logo Section */}
        <div className="sidebar-logo">
          <div className="logo-icon">
            <img
              src={process.env.PUBLIC_URL + '/logo.jpg'}
              alt="Mountain Top University"
              className="admin-dashboard-logo-image"
            />
          </div>
          <div className="logo-text">
            <div className="logo-title">MTU Alumni</div>
            <div className="logo-subtitle">Event Management</div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <div className="nav-item" onClick={() => handleNavClick('/admin/dashboard')}>
            <DashboardIcon />
            <span>Dashboard</span>
          </div>
          <div className="nav-item" onClick={() => handleNavClick('/admin/registrations')}>
            <RegistrationsIcon />
            <span>Registrations</span>
          </div>
          <div className="nav-item" onClick={() => handleNavClick('/admin/generate-ticket')}>
            <TicketIcon />
            <span>Generate Ticket</span>
          </div>
          <div className="nav-item" onClick={() => handleNavClick('/admin/checkin')}>
            <CheckInIcon />
            <span>Check-in</span>
          </div>
          <div className="nav-item active" onClick={closeSidebar}>
            <BroadcastIcon />
            <span>Email Broadcast</span>
          </div>
          <div className="nav-item" onClick={() => handleNavClick('/admin/dashboard?export=1')}>
            <ExportIcon />
            <span>Export Data</span>
          </div>
          <div className="nav-item" onClick={() => handleNavClick('/admin/settings')}>
            <SettingsIcon />
            <span>Settings</span>
          </div>
        </nav>

        {/* User Profile */}
        <div className="sidebar-user">
          <div className="user-info">
            <div className="user-avatar">
              {getUserInitials(user?.email || 'Admin User')}
            </div>
            <div className="user-details">
              <div className="user-name">Admin User</div>
              <div className="user-email">{user?.email || 'admin@mtu.edu'}</div>
            </div>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            <LogoutIcon />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="broadcast-main">
        {/* Header */}
        <header className="broadcast-header">
          <div className="header-content">
            <div className="header-left">
              <h1 className="header-title">Email Broadcast</h1>
              <p className="header-subtitle">
                Send email notifications to all paid attendees
              </p>
            </div>
            <div className="header-right">
              <button className="hamburger-button" onClick={toggleSidebar} aria-label="Toggle menu">
                <HamburgerIcon />
              </button>
            </div>
          </div>
        </header>

        <div className="broadcast-content">
          {loading ? (
            <div className="broadcast-loading">
              <div className="loading-spinner"></div>
              <p>Loading paid attendees...</p>
            </div>
          ) : (
            <>
              {/* Info Banner */}
              <div className="broadcast-info-banner">
                <div className="info-icon-circle">i</div>
                <div className="info-text">
                  <h3>Important Information</h3>
                  <p>
                    This message will be sent only to users whose registration status is
                    <strong> Paid</strong>. Pending or deleted registrations will not receive this email.
                  </p>
                </div>
                <div className="info-stats">
                  <div className="paid-pill">
                    Paid Users: {paidRecipients.length}
                  </div>
                </div>
              </div>

              {/* Main Form + Recent section */}
              <div className="broadcast-grid">
                {/* Form Card */}
                <div className="broadcast-form-card">
                  <div className="broadcast-card-inner">
                    {/* Subject */}
                    <div className="form-group">
                      <label htmlFor="subject">
                        Email Subject <span className="required">*</span>
                      </label>
                      <input
                        id="subject"
                        type="text"
                        placeholder="Enter email subject..."
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>

                    {/* Message */}
                    <div className="form-group">
                      <label htmlFor="message">
                        Message Body <span className="required">*</span>
                      </label>
                      <textarea
                        id="message"
                        rows={8}
                        placeholder="Compose your email message here..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>

                    {/* Footer actions */}
                    <div className="broadcast-footer-actions">
                      <div className="left-actions">
                        <button
                          type="button"
                          className="secondary-button"
                          onClick={() => {
                            setSubject('');
                            setMessage('');
                          }}
                          disabled={sending}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="right-actions">
                        <button
                          type="button"
                          className="primary-button"
                          onClick={handleSendBroadcast}
                          disabled={sending}
                        >
                          {sending ? 'Sending...' : 'Send Email'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Recent Broadcasts */}
                <div className="broadcast-recent-card">
                  <div className="recent-header">
                    <h3>Recent Broadcasts</h3>
                    <p>History of your email broadcasts</p>
                  </div>
                  {loadingBroadcasts ? (
                    <div className="recent-loading">
                      <div className="loading-spinner-small"></div>
                      <p>Loading history...</p>
                    </div>
                  ) : recentBroadcasts.length === 0 ? (
                    <div className="recent-empty">
                      <p>No broadcast history yet.</p>
                    </div>
                  ) : (
                    <div className="recent-list">
                      {recentBroadcasts.slice(0, 10).map((broadcast) => (
                        <div key={broadcast.id} className="recent-item">
                          <div className="recent-item-content">
                            <h4 className="recent-item-subject">{broadcast.subject}</h4>
                            <div className="recent-item-meta">
                              <span className="recent-item-time">{formatDate(broadcast.sentAt)}</span>
                              <span className="recent-item-count">
                                {broadcast.totalSent || (broadcast.recipientIds?.length || 0)} sent
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default EmailBroadcastPage;


